<template>
    <div class="container">
        <h2 class="text-muted">Détail du tissu</h2>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="d-flex justify-content-between">
                    <strong>Nom de tissu : </strong> <span class="card-text">{{ tissu.label }}</span>
                </div>
                <div class="d-flex justify-content-between">
                    <strong>Type de tissu : </strong> <span class="card-text">{{ tissu.type_tissu?.label }}</span>
                </div>
                <div class="d-flex justify-content-between">
                    <strong>Couleur : </strong> <span class="card-text">{{ tissu.color }}</span>
                </div>
                <div class="d-flex justify-content-between">
                    <strong>Qualité : </strong> <span class="card-text">{{ tissu.quality }}</span>
                </div>
                <div class="d-flex justify-content-between">
                    <strong>Quantité : </strong> <span class="card-text">{{ tissu.quantity }}</span>
                </div>
            </div>

            <div v-if="tissu.image_path">
                <div class="card">
                    <div class="card-body">
                        <img :src="$api.defaults.assetsBaseURL + tissu.image_path" alt="Image du tissu"
                            class="img-fluid image-preview" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TissuView',
    props: {
        id: {
            type: [String, Number],
            require: true
        }
    },
    data() {
        return {
            tissu: {}
        }
    },
    methods: {
        getTissu() {
            this.$api.get(`/tissus/${this.id}`)
                .then(response => {
                    this.tissu = response.data.data;
                }
                )
                .catch(error => {
                    console.log(error);
                })
        }
    },

    created() {
        this.getTissu();
    }
}
</script>